export const permissionTypes = [
  { id: 1, key: "view", label: "View" },
  { id: 2, key: "edit", label: "Edit" },
  { id: 3, key: "export", label: "Export" },
  {
    id:4,key:"delete",label:"Delete"
  },
];